export const BuildInfo = {timestamp:1772663882000}
